import { z } from 'zod';

/**
 * Catálogo fechado de features instrumentadas no Android via PostHog
 * `feature_used` event (Sprint 4.8). Cada FeatureId corresponde a
 * uma ação de produto que vale rastrear para o dashboard /product
 * (Sprint 4.12).
 */
export const FeatureIdSchema = z.enum([
  'BARCODE_GENERATION',
  'BULK_PRINT',
  'PRODUCT_TEMPLATE',
  'LABEL_HISTORY',
  'SCAN',
  'EXPORT_LABELS',
  'INVITE_USER',
  'ADD_PRINTER',
  'PRINT_PREVIEW',
]);
export type FeatureId = z.infer<typeof FeatureIdSchema>;
export const ALL_FEATURE_IDS = FeatureIdSchema.options;
